import * as React from "react";
import { UserContext } from "../../../contexts/user.context";
import { t } from "i18next";
import { FilePond } from "react-filepond";
import {
  AddButton,
  ButtonsContainer,
  CancelButton,
} from "../addClientModal/addClientModal.styles";
import { SendFormData, handleError } from "../../../utils/fetch.util";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

interface AddSatffDocumentModelProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  getAllItems: () => void;
  editStaffDocument: any;
  setEditStaffDocument: React.Dispatch<any>;
}

interface StaffDocument {
  title: string;
  description: string;
  image_url: any;
}

const AddSatffDocumentModel: React.FC<AddSatffDocumentModelProps> = ({
  open,
  setOpen,
  getAllItems,
  setEditStaffDocument,
  editStaffDocument,
}) => {
  const defaultStaffDocument = {
    title: "",
    description: "",
    image_url: [],
  };
  const { staffId } = useParams();
  const [staffDocument, setStaffDocument] =
    React.useState<StaffDocument>(defaultStaffDocument);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const { getValidToken } = React.useContext(UserContext);

  const handleAdd = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData();

    if (staffId){
    formData.append("staff_id", staffId);
  }
    formData.append("title", staffDocument.title);
    formData.append("description", staffDocument.description);
    const imageUrlModified =
      staffDocument.image_url?.length > 0 &&
      staffDocument.image_url[0]?.file !== undefined;

    if (imageUrlModified) {
      staffDocument.image_url.forEach((item: any) =>
        formData.append("image_url", item.file),
      );
    }

    const res = await SendFormData(
      "staff-documents/add-staff-document",
      formData,
      getValidToken(),
    );

    if (res.error || !res.data) {
      handleError(res);
      setIsLoading(false);
      return;
    }

    toast.success("Successfully Added");
    setStaffDocument(defaultStaffDocument);
    setIsLoading(false);
    getAllItems();
    setOpen(false);
  };

  const handleEdit = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData();

    if (staffId) {
      formData.append("staff_id", staffId);
    }
    formData.append("document_id", editStaffDocument.id);
    formData.append("title", staffDocument.title);
    formData.append("description", staffDocument.description);
    const imageUrlModified =
      staffDocument.image_url?.length > 0 &&
      staffDocument.image_url[0]?.file !== undefined;

    if (imageUrlModified) {
      staffDocument.image_url.forEach((item: any) =>
        formData.append("image_url", item.file),
      );
    }

    const res = await SendFormData(
      "staff-documents/update-staff-document",
      formData,
      getValidToken(),
      "PATCH",
    );

    if (res.error || !res.data) {
      handleError(res);
      setIsLoading(false);
      return;
    }

    toast.success("Successfully Edited");
    setStaffDocument(defaultStaffDocument);
    setEditStaffDocument(null);
    setIsLoading(false);
    getAllItems();
    setOpen(false);
  };

  React.useEffect(() => {
    editStaffDocument &&
      setStaffDocument({
        title: editStaffDocument.title,
        description: editStaffDocument.description,
        image_url: `${import.meta.env.VITE_API_URL}${
          editStaffDocument.image_url
        }`,
      });
  }, []);

  return (
    <>
      <div
        className={`toggle_server_model fixed top-0 left-0 w-full h-full bg-[#00000075] flex items-center justify-center !z-[99999] ${
          open ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        <div
          className="fixed top-0 left-0 w-full h-[100vh] cursor-pointer"
          onClick={() => {
            setOpen(false);
            setStaffDocument(defaultStaffDocument);
            setEditStaffDocument(null);
          }}
        ></div>
        <form
          className={`bg-white w-full max-w-[500px] p-6 relative z-[9999] max-h-[90vh] overflow-x-auto rounded-lg`}
          onSubmit={editStaffDocument ? handleEdit : handleAdd}
        >
          <h2 className="text-3xl mb-6 !text-black">
            {t(
              editStaffDocument ? "edit_staff_document" : "add_staff_document",
            )}
          </h2>
          <div className="flex flex-col gap-2 mt-5">
            <label aria-required>{t("title")}</label>
            <input
              onChange={(e) =>
                setStaffDocument((prev) => {
                  return { ...prev, title: e.target.value };
                })
              }
              value={staffDocument.title}
              name="title"
              className="border"
              type="text"
              required
            />
          </div>
          <div className="flex flex-col gap-2 mt-5">
            <label aria-required>{t("description")}</label>
            <input
              onChange={(e) =>
                setStaffDocument((prev) => {
                  return { ...prev, description: e.target.value };
                })
              }
              value={staffDocument.description}
              name="description"
              className="border"
              type="text"
              required
            />
          </div>
          <div className="flex flex-col gap-2 mt-5">
            <label aria-required>{t("description")}</label>
            <FilePond
              files={staffDocument.image_url}
              onupdatefiles={(files) => {
                setStaffDocument((prev) => {
                  return { ...prev, image_url: files };
                });
              }}
              allowMultiple={false}
              allowReorder
              allowImagePreview
              allowImageExifOrientation
              maxFiles={10}
              acceptedFileTypes={["image/jpeg", "image/png", "image/avif"]}
              credits={false}
              labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
            />
          </div>
          <ButtonsContainer style={{ gap: "2rem" }}>
            <AddButton isLoading={isLoading} type="submit">
              {t("submit")}
            </AddButton>
            <CancelButton
              type="button"
              style={{ border: "2px solid black" }}
              onClick={() => {
                setOpen(false);
                setStaffDocument(defaultStaffDocument);
                setEditStaffDocument(null);
              }}
            >
              {t("cancelBtn")}
            </CancelButton>
          </ButtonsContainer>
        </form>
      </div>
    </>
  );
};

export default AddSatffDocumentModel;
